import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Problems from "@/components/Problems";
import Solution from "@/components/Solution";
import Process from "@/components/Process";
import Journey from "@/components/Journey";
import Footer from "@/components/Footer";

// Lazy load below-the-fold components for better TTI
const Results = lazy(() => import("@/components/Results"));
const About = lazy(() => import("@/components/About"));
const FAQ = lazy(() => import("@/components/FAQ"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <Problems />
        <Solution />
        <Process />
        <Journey />
        <Suspense fallback={<div className="h-96 bg-muted/20 animate-pulse rounded-lg mx-4" />}>
          <Results />
        </Suspense>
        <Suspense fallback={<div className="h-96 bg-muted/20 animate-pulse rounded-lg mx-4" />}>
          <About />
        </Suspense>
        <Suspense fallback={<div className="h-96 bg-muted/20 animate-pulse rounded-lg mx-4" />}>
          <FAQ />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
